import { showToast } from "./customToast";

/**
 * Professional session wipeout & cache cleanup on Logout
 * - Wipes all sensitive session data, tokens, user and company data
 * - Clears sessionStorage
 * - Clears browser CacheStorage (window.caches)
 * - Retains ONLY remembered username if "Remember Me" is enabled
 * - Cleans up cookies
 * - Redirects to login
 */
export const performLogout = async (message = "Logged out successfully") => {
  try {
    // 1. Check Remember Me preference
    const isRemembered = localStorage.getItem("rememberMe") === "true";
    const savedUser = localStorage.getItem("savedUsername") || "";

    // 2. Clear all sensitive Local Storage
    localStorage.clear();

    // 3. Clear Session Storage
    sessionStorage.clear();

    // 4. Restore ONLY Remembered Username if requested
    if (isRemembered && savedUser) {
      localStorage.setItem("rememberMe", "true");
      localStorage.setItem("savedUsername", savedUser);
    }

    // 5. Clear Browser Cache Storage (window.caches)
    if (typeof window !== "undefined" && "caches" in window) {
      try {
        const cacheKeys = await window.caches.keys();
        await Promise.all(cacheKeys.map((key) => window.caches.delete(key)));
      } catch (cacheErr) {
        console.warn("Cache storage cleanup warning:", cacheErr);
      }
    }

    // 6. Clear auth cookies if any exist
    try {
      if (typeof document !== "undefined" && document.cookie) {
        const cookies = document.cookie.split(";");
        for (let i = 0; i < cookies.length; i++) {
          const cookie = cookies[i];
          const eqPos = cookie.indexOf("=");
          const name = eqPos > -1 ? cookie.substr(0, eqPos).trim() : cookie.trim();
          if (name) {
            document.cookie = `${name}=;expires=Thu, 01 Jan 1970 00:00:00 GMT;path=/`;
          }
        }
      }
    } catch (cookieErr) {
      console.warn("Cookie cleanup warning:", cookieErr);
    }

    // 7. Notify & Redirect
    if (message) {
      showToast.success(message);
    }

    // Brief delay to allow toast to render or trigger redirect
    setTimeout(() => {
      window.location.href = "/";
    }, 250);
  } catch (error) {
    console.error("Logout error:", error);
    localStorage.clear();
    sessionStorage.clear();
    window.location.href = "/";
  }
};
